import axios from "axios"
export function getCampaignDetailsAdmin(token, advertismentId) {
    return axios.get(process.env.REACT_APP_API_URL + `/getCampaignDetailsAdmin?advertismentId=${advertismentId}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}